import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, CardHeader, Col, Spinner } from 'reactstrap';
import { getOrders } from '../../api/ecommerce';

const RecentOrders = () => {
    const [orders, setOrders] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        getOrders()
            .then((res) => {
                const data = res?.data || res || [];
                setOrders(Array.isArray(data) ? data.slice(0, 5) : []);
            })
            .catch(() => setOrders([]))
            .finally(() => setLoading(false));
    }, []);

    const mapOrder = (o) => {
        const addr = typeof o.shipping_address === 'string' ? JSON.parse(o.shipping_address || '{}') : (o.shipping_address || {});
        const items = typeof o.items === 'string' ? JSON.parse(o.items || '[]') : (o.items || []);
        const productLabel = items.length > 0 ? (items[0].name + (items.length > 1 ? ` +${items.length - 1}` : '')) : '-';
        const statusClass = (o.payment_status || o.order_status || 'pending') === 'paid' ? 'success' : 'warning';
        return {
            orderId: '#' + (o.order_number || o.id),
            name: addr.fullName || o.email || '-',
            product: productLabel,
            amount: Number(o.total || 0).toFixed(2),
            status: o.payment_status || o.order_status || 'Pending',
            statusClass
        };
    };

    return (
        <React.Fragment>
            <Col xl={6}>
                <Card>
                    <CardHeader className="align-items-center d-flex">
                        <h4 className="card-title mb-0 flex-grow-1">Recent Orders</h4>
                        <div className="flex-shrink-0">
                            <Link to="/orders" className="btn btn-soft-info btn-sm">
                                <i className="ri-file-list-3-line align-middle"></i> View All
                            </Link>
                        </div>
                    </CardHeader>

                    <CardBody>
                        {loading ? (
                            <div className="text-center py-4"><Spinner /><p className="mt-2 text-muted">Loading...</p></div>
                        ) : (
                            <div className="table-responsive table-card">
                                <table className="table table-borderless table-centered align-middle table-nowrap mb-0">
                                    <thead className="text-muted table-light">
                                        <tr>
                                            <th scope="col">Order ID</th>
                                            <th scope="col">Customer</th>
                                            <th scope="col">Product</th>
                                            <th scope="col">Amount</th>
                                            <th scope="col">Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {(orders || []).map((item, key) => {
                                            const row = mapOrder(item);
                                            return (
                                                <tr key={key}>
                                                    <td>
                                                        <Link to={`/orders`} className="fw-medium link-primary">{row.orderId}</Link>
                                                    </td>
                                                    <td>{row.name}</td>
                                                    <td>{row.product}</td>
                                                    <td><span className="text-success">£{row.amount}</span></td>
                                                    <td>
                                                        <span className={"badge bg-" + row.statusClass + "-subtle text-" + row.statusClass}>{row.status}</span>
                                                    </td>
                                                </tr>
                                            );
                                        })}
                                        {orders.length === 0 && !loading && (
                                            <tr><td colSpan="5" className="text-center py-4 text-muted">No orders yet</td></tr>
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </CardBody>
                </Card>
            </Col>
        </React.Fragment>
    );
};

export default RecentOrders;